import { render, staticRenderFns } from "./SchemasView.vue?vue&type=template&id=c4cf8238&"
import script from "./SchemasView.vue?vue&type=script&lang=js&"
export * from "./SchemasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports